var _path, _path2, _g, _g2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.39,4.03v4.01s-2.09,3.64-2.21,3.61c-.12-.03-.15-.33-.15-.33v-2.58c0-.36.55-.64.55-.64l.06-4.24s.28-.62.9-.62.85.79.85.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.33,4.07v4.01s2.09,3.64,2.21,3.61c.12-.03.15-.33.15-.33v-2.58c0-.36-.55-.64-.55-.64l-.06-4.24s-.28-.62-.9-.62-.85.79-.85.79Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.66,30.98l-4.66,5.18-4.5-1.76,4.7-4.73h3.23c.04.36,1.23,1.31,1.23,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.06,31.27l-4.61,5.18,2.47,4.81s1.99.71,3.03-.47,4.16-4.55,4.16-4.55c0,0,.33-2.24.04-2.64s-1.6-1.8-1.6-1.8c0,0-1.67.53-3.5-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87,36.62l-4.5-1.76,4.17,5.56s1.67.72,2.85.97l-2.52-4.77Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.05,30.98l4.66,5.18,4.5-1.76-4.7-4.73h-3.23c-.04.36-1.23,1.31-1.23,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.65,31.27l4.61,5.18-2.47,4.81s-1.99.71-3.03-.47-4.16-4.55-4.16-4.55c0,0-.33-2.24-.04-2.64s1.6-1.8,1.6-1.8c0,0,1.67.53,3.5-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.85,36.62l4.5-1.76-4.17,5.56s-1.67.72-2.85.97l2.52-4.77Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06,25.21s.62.39,1.64.43,28.16,0,28.16,0c0,0,.89.05,1.6-.48,0,0-.4,2.41-.67,2.85s-.58.92-1.29.97-27.45,0-27.45,0c0,0-.98-.34-1.15-.77s-.84-2.99-.84-2.99Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.26,24.98c-.15.02-.32.04-.5.05-4.31.24-15.07,0-15.07,0-1.84.02-4.53.06-7.1.06-2.15,0-4.23-.02-5.63-.1-.16-.01-.3-.02-.45-.04h-.01c-3.71-.57-2.04-5.31-2.04-5.31,0,0,5.97-9.89,6.9-12.09.95-2.19,2.83-1.81,2.83-1.81l7.54.05h5.83s1.88-.4,2.82,1.81c.95,2.19,6.91,12.09,6.91,12.09,0,0,1.66,4.68-2.02,5.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitIcon);
export default __webpack_public_path__ + "static/media/unit_icon.205e9042bd1d70faf78bd5bd63d3d841.svg";
export { ForwardRef as ReactComponent };